module.exports = __webpack_public_path__ + "b39246cb557f91c37c096710506340a3.svg";